import { gql } from "@apollo/client";

export const REFERENTIALS = gql`
  query Referentials(
    $where: ReferentialWhereInput
    $take: Int
    $skip: Int
    $orderBy: [JSONObject]
  ) {
    referentials(where: $where, take: $take, skip: $skip, orderBy: $orderBy) {
      data {
        id
        name
        type
        entries
        createdDate
        ownedBy {
          id
          name
        }
      }
      count
    }
  }
`;

export const REFERENTIAL = gql`
  query Referential($where: ReferentialWhereInput) {
    referential(where: $where) {
      id
      name
      type
      entries
      createdDate
      ownedBy {
        id
        name
      }
    }
  }
`;

const geoZones = { REFERENTIALS, REFERENTIAL };

export default geoZones;
